import React, { useState } from "react"

import { publicClient as client } from "src/urql-client"

import { gql, useQuery } from "hooks/urql"

import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

import Card from "./Card"
import CollegeForm from "./CollegeForm"
import ParentForm from "./ParentForm"
import RegistrationContext from "./RegistrationContext"

const RegistrationWizard = ({ referralToken, referralUserType }) => {
  const [result] = useQuery({
    query: registrationQuery,
    variables: { referralToken },
    client,
  })

  const userTypeFromReferral =
    referralUserType === "parent" ? "parent" : "college"
  const initialUserType = referralToken ? userTypeFromReferral : undefined
  const [userType, setUserType] = useState(initialUserType)

  const reset = () => {
    setUserType(undefined)
  }

  return (
    <UrqlLoadingIndicator result={result}>
      {({ data: { tiers, referral } }) => (
        <RegistrationContext.Provider
          value={{
            tiers,
            grades: tiers.map(t => t.grades).flat(),
            referral: referral,
          }}
        >
          <div className="mx-6 sm:mx-auto lg:w-3/4">
            <h1 className="text-center">Air Tutors Registration</h1>
            {referral && (
              <div className="alert alert-success my-3 !mr-0 bg-green-600 p-3">
                Welcome, {referral.firstName}! {referral.referrer.fullName} has
                invited you to create an Air Tutors account.
              </div>
            )}
            {userType ? null : (
              <>
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
                  <Card
                    title="New to Air Tutors"
                    description="Create parent account"
                    onClick={() => setUserType("parent")}
                  />
                  <Card
                    title={
                      <>
                        My Student Uses{" "}
                        <span className="whitespace-nowrap">Air Tutors</span>
                      </>
                    }
                    description="Create a parent account to manage my student's Air Tutors account"
                    href="/users/sign_in?openParentModal=true"
                  />
                  <Card
                    title="College Student or Adult Learner"
                    description="Create an account to manage your own Air Tutors experience"
                    onClick={() => setUserType("college")}
                  />
                </div>
              </>
            )}
            {userType === "parent" && <ParentForm reset={reset} />}
            {userType === "college" && <CollegeForm reset={reset} />}
            <div className="mt-5 text-center">
              <div>Already have an account?</div>
              <div>
                <a href="/users/sign_in?programRegistration=true">
                  Click here to login
                </a>
              </div>
            </div>
          </div>
        </RegistrationContext.Provider>
      )}
    </UrqlLoadingIndicator>
  )
}

const registrationQuery = gql`
  query RegistrationWizard($referralToken: String) {
    referral(token: $referralToken) {
      id
      userType
      firstName
      lastName
      phoneNumber
      email
      grade {
        id
      }
      referrer {
        id
        firstName
        fullName
      }
    }
    tiers {
      id
      name
      gradeRange
      grades {
        id
        name
        number
      }
    }
  }
`

export default RegistrationWizard
